export interface Testimonial {
  nombre: string;
  edad: number;
  ciudad: string;
  texto: string;
  foto?: string;
}

export const testimoniosDestacados: Testimonial[] = [
  {
    nombre: 'Mariana L.',
    edad: 34,
    ciudad: 'Barcelona',
    texto: 'En solo 4 días la hinchazón bajó increíblemente. No lo podía creer. Ahora me pongo ropa que hace años no usaba 😭'
  },
  {
    nombre: 'Sandra M.',
    edad: 41,
    ciudad: 'Madrid',
    texto: 'Pensé que iba a ser comida aburrida... ¡pero las recetas son DELICIOSAS! Mi marido ahora me pide los postres 😂'
  },
  {
    nombre: 'Carla R.',
    edad: 28,
    ciudad: 'Sevilla',
    texto: 'Lo mejor fue dejar de pensar cada día: "¿qué cocino?" Me sacó un estrés ENORME. Ahora la cocina es fácil'
  },
  {
    nombre: 'Valentina P.',
    edad: 36,
    ciudad: 'Valencia',
    texto: 'Tengo colon irritable y casi nada me sentaba bien. Estas recetas me ayudaron muchísimo. Finalmente puedo comer sin miedo'
  },
  {
    nombre: 'Daniela M.',
    edad: 29,
    ciudad: 'Bilbao',
    texto: 'Los postres saludables me salvaron. Era ADICTA al azúcar. Ahora disfruto cosas dulces sin culpa y sin desinflarme'
  },
  {
    nombre: 'Andrea R.',
    edad: 45,
    ciudad: 'Málaga',
    texto: 'Bajé 3 kilos sin hacer dieta. Simplemente comía mejor. Nunca me había sentido así. La comida dejó de ser el enemigo'
  }
];

export const testimoniosExtra: Testimonial[] = [
  {
    nombre: 'Patricia G.',
    edad: 32,
    ciudad: 'Barcelona',
    texto: 'Hay recetas que hago en 15 minutos. Me solucionaron las cenas por completo'
  },
  {
    nombre: 'Lucía F.',
    edad: 38,
    ciudad: 'Madrid',
    texto: 'Pensé que sería "comida sana aburrida" y mi familia terminó fascinada 😂'
  },
  {
    nombre: 'Isabel V.',
    edad: 42,
    ciudad: 'Zaragoza',
    texto: 'No sabía que la inflamación venía de ciertos ingredientes. Al eliminarlos, todo cambió'
  },
  {
    nombre: 'Rosa M.',
    edad: 35,
    ciudad: 'Valencia',
    texto: 'El Diario de Síntomas me cambió la vida. Ahora entiendo por qué reacciona mi cuerpo'
  },
  {
    nombre: 'Alejandra C.',
    edad: 31,
    ciudad: 'Córdoba',
    texto: 'La garantía me dio la seguridad para probar. No necesité usarla, funciona genial'
  }
];
